import { useLazyQuery } from "@apollo/client"
import { GET_ORDER_PDF_URL } from "../graphql/queries/getOrderPdfUrl"

export const useOrderPdfUrl = () => {
  const [getOrderPdfUrl, { data, error, loading }] = useLazyQuery(GET_ORDER_PDF_URL)
  return { pdfUrl: data?.order?.pdfUrl as string, error, loading, getOrderPdfUrl }
}
